<mat-form-field2 class="mat-block" [showLabel]="false">
  <input
    matInput
    [formControl]="roleViewCtrl"
    type="text"
    i18n-placeholder
    i18n-matTooltip
    placeholder="Select a Signing Role"
    matTooltip="click here to select whether this signer will be one of your guests, or a user from your account."
    [disabled]="!isEditable"
    required
    [matAutocomplete]="auto"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onRoleSelect($event)">
    <mat-option *ngFor="let role of availableRoles" [value]="role.value">
      {{ role.label }}
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="isDuplicated" i18n>This signing role is already in use.</mat-error>
</mat-form-field2>
